import { ChatbotUIAction, UserActionType } from '@wix/ambassador-funnel-chatbot-v1-session/types';
import { useDispatch, useSelector } from 'react-redux';

import { UI } from '../../../constants';
import { isString } from '../../../util/guards';
import { sendUserAction } from '../api/sendUserAction';
import { useHttpClient } from '../providers/httpClient';
import { chatActions } from '../reducers/chat';
import { selectConversationId } from '../selectors/chat';
import { selectFieldNodeId } from '../selectors/field';
import { selectLoadPageUrl } from '../selectors/meta';

export const useUserAction = (
  type: UI.CLOSE_LIVE_CHAT | UI.CANT_LOGIN_CLICKED | UI.CHANGE | UI.NAVIGATED | UI.DIRECT_SUPPORT_REQUESTED,
  id?: string,
) => {
  const httpClient = useHttpClient();
  const dispatch = useDispatch();
  const nodeId = useSelector(selectFieldNodeId);
  const conversationId = useSelector(selectConversationId);
  const loadPageUrl = useSelector(selectLoadPageUrl);

  type TDetails = {
    endedBy?: string;
    nodeId?: string;
    label?: string;
  };

  return (detail: TDetails) => {
    let action: UserActionType = {};

    // eslint-disable-next-line default-case
    switch (type) {
      case UI.CLOSE_LIVE_CHAT:
        action = {
          type: ChatbotUIAction.CLOSE_LIVE_CHAT,
          closeLiveChat: {
            ...detail,
            loadPageUrl,
          },
        };
        break;
      case UI.CANT_LOGIN_CLICKED:
        action = {
          type: ChatbotUIAction.CANT_LOGIN_CLICKED,
          cantLoginClicked: {
            loadPageUrl,
          },
        };
        break;
      case UI.CHANGE:
        action = {
          type: ChatbotUIAction.CHANGE,
          change: {
            ...detail,
            loadPageUrl,
          },
        };
        break;
      case UI.NAVIGATED:
        action = {
          type: ChatbotUIAction.NAVIGATED,
          navigated: {
            ...detail,
            url: loadPageUrl,
          },
        };
        break;
      case UI.DIRECT_SUPPORT_REQUESTED:
        action = {
          type: ChatbotUIAction.DIRECT_SUPPORT_REQUESTED,
          directSupportRequested: {
            ...detail,
          },
        };
        break;
    }

    return sendUserAction(action, conversationId, nodeId, httpClient, loadPageUrl)
      .then(() => true)
      .catch(() => {
        if (isString(id)) {
          dispatch(chatActions.addUndelivered({ [id]: action }));
        }

        return false;
      });
  };
};
